<div class="lg-container l-h-2">
  <label class="font-label" >{{'LEAD_GENERATION.CREATOR.BUBBLE.CHOOSE' | translate}}</label>
  <div class="select-box">
    <mat-select
      [formControl]="control">
      <mat-option
        *ngFor="let item of fonts"
        [value]="item.name">{{item.name}}
      </mat-option>
    </mat-select>
  </div>
</div>
